import { GetObjectStatusColor } from "./types";

export const getObjectStatusColor: GetObjectStatusColor = ({
  status,
  isActive,
}) => {
  if (isActive) return "#ffff00";
  if (status === "installed") return "#ff00ff";
  return "#ff0000";
};
